export const translations = {
  es: {
    nav: {
      home: "Inicio",
      tours: "Tours",
      reviews: "Opiniones",
      gallery: "Galería",
      faq: "FAQ",
      book: "Reservar"
    },
    hero: {
      title: "Madrid Tuk Tuk Tour",
      subtitle: "Un tour privado por Madrid a través de su historia",
      cta: "Reservar Tour"
    },
    tours: {
      title: "Nuestros Tours",
      subtitle: "Descubre Madrid de una forma única",
      duration: "Duración",
      from: "Desde",
      viewMap: "Ver mapa",
      book: "Reservar",
      option3h: "3 horas",
      option6h: "6 horas"
    },
    howItWorks: {
      title: "¿Cómo funciona?",
      step1: {
        title: "Reserva tu tour",
        desc: "Elige el tour que más te guste y selecciona fecha y hora"
      },
      step2: {
        title: "Te recogemos",
        desc: "En tu hotel o punto de encuentro acordado"
      },
      step3: {
        title: "Recorre Madrid",
        desc: "Disfruta del paseo en nuestro tuk-tuk eléctrico"
      },
      step4: {
        title: "Descubre la historia",
        desc: "Aprende sobre Madrid con nuestro guía historiador"
      }
    },
    guide: {
      title: "Tu Guia",
      name: "Carlos Casal",
      age: "25 anos",
      role: "Historiador",
      bio_short: "Carlos Casal, historiador de 25 anos, nacio y crecio en Madrid, una ciudad por la que siente una profunda pasion y curiosidad historica. Desde muy joven se ha interesado por comprender como se ha formado la ciudad a lo largo de los siglos y cual ha sido su papel dentro de la historia de Espana. Con esa motivacion creo estos tours, con el objetivo de ofrecer una forma diferente de descubrir Madrid: no solo recorriendo sus calles, sino tambien entendiendo el contexto historico que las ha moldeado.",
      bio_rest: "Durante varios anos vivio en el extranjero, principalmente en Estados Unidos y Paris, una etapa que le permitio ampliar su vision cultural y perfeccionar sus idiomas, especialmente el ingles y el frances. Esta experiencia internacional le ha ayudado a conectar con visitantes de diferentes paises y a transmitir la historia de Madrid de una forma cercana y accesible.\n\nEn sus recorridos, Carlos combina su conocimiento historico con su entusiasmo por compartirlo. Su caracter cercano, sociable y amable convierte cada tour en una experiencia dinamica y agradable, donde los visitantes no solo descubren los lugares mas emblematicos de la ciudad, sino que tambien comprenden las historias y curiosidades que los hacen unicos. Su objetivo es que cada persona que participe en el tour encuentre una manera autentica y memorable de introducirse en la historia y el espiritu de Madrid."
    },
    reviews: {
      title: "Lo que dicen nuestros clientes",
      subtitle: "Miles de turistas han disfrutado de nuestros tours"
    },
    faq: {
      title: "Preguntas Frecuentes",
      subtitle: "Todo lo que necesitas saber"
    },
    gallery: {
      title: "Galería",
      subtitle: "Momentos de nuestros tours"
    },
    contact: {
      title: "Contacto",
      subtitle: "¿Tienes alguna pregunta?",
      whatsapp: "WhatsApp",
      email: "Email",
      phone: "Teléfono"
    },
    booking: {
      title: "Reservar Tour",
      selectTour: "Selecciona un tour",
      selectDate: "Selecciona fecha",
      selectTime: "Selecciona hora",
      guests: "Número de personas",
      adults: "Adultos",
      children: "Niños (menos de 140cm)",
      childSeats: "Sillas infantiles necesarias",
      contactInfo: "Información de contacto",
      name: "Nombre completo",
      email: "Email",
      phone: "Teléfono",
      pickup: "Punto de recogida",
      hotel: "Nombre del hotel (opcional)",
      pickupPoint: "Punto de encuentro",
      pickupPoints: {
        opera: "Plaza de Isabel II (Ópera)",
        neptuno: "Fuente de Neptuno",
        prado: "Museo del Prado",
        debod: "Templo de Debod"
      },
      specialRequests: "Peticiones especiales (opcional)",
      payment: "Método de pago",
      payOnline: "Pago online (tarjeta)",
      payCash: "Pago en efectivo (durante el tour)",
      total: "Total",
      confirm: "Confirmar Reserva",
      payNow: "Pagar Ahora",
      processing: "Procesando...",
      success: "¡Reserva Confirmada!",
      successMessage: "Tu reserva ha sido confirmada. Recibirás un email con los detalles.",
      error: "Error al procesar la reserva",
      maxCapacity: "Máximo 4 pasajeros por tuk-tuk (adultos y niños incluidos)",
      groupDiscount: "Para grupos de más de 10 personas, contáctanos para descuentos especiales."
    },
    footer: {
      tagline: "Descubre Madrid a través de su historia",
      tours: "Tours",
      info: "Información",
      contact: "Contacto",
      schedule: "Horarios",
      summerSchedule: "Verano: 10:00 - 22:00",
      winterSchedule: "Invierno: 10:00 - 19:00",
      everyDay: "Todos los días",
      rights: "Todos los derechos reservados"
    }
  },
  en: {
    nav: {
      home: "Home",
      tours: "Tours",
      reviews: "Reviews",
      gallery: "Gallery",
      faq: "FAQ",
      book: "Book Now"
    },
    hero: {
      title: "Madrid Tuk Tuk Tour",
      subtitle: "A private tour through Madrid via its history",
      cta: "Book Tour"
    },
    tours: {
      title: "Our Tours",
      subtitle: "Discover Madrid in a unique way",
      duration: "Duration",
      from: "From",
      viewMap: "View map",
      book: "Book",
      option3h: "3 hours",
      option6h: "6 hours"
    },
    howItWorks: {
      title: "How does it work?",
      step1: {
        title: "Book your tour",
        desc: "Choose your preferred tour and select date and time"
      },
      step2: {
        title: "We pick you up",
        desc: "At your hotel or agreed meeting point"
      },
      step3: {
        title: "Explore Madrid",
        desc: "Enjoy the ride in our electric tuk-tuk"
      },
      step4: {
        title: "Discover history",
        desc: "Learn about Madrid with our historian guide"
      }
    },
    guide: {
      title: "Your Guide",
      name: "Carlos Casal",
      age: "25 years old",
      role: "Historian",
      bio_short: "Carlos Casal, a 25-year-old historian, was born and raised in Madrid, a city for which he feels a deep passion and historical curiosity. From a young age, he has been interested in understanding how the city has been shaped over the centuries and what role it has played in the history of Spain. With that motivation, he created these tours, aiming to offer a different way to discover Madrid: not just by riding through its streets, but also by understanding the historical context that has shaped them.",
      bio_rest: "He lived abroad for several years, mainly in the United States and Paris, a period that allowed him to broaden his cultural vision and perfect his languages, especially English and French. This international experience has helped him connect with visitors from different countries and convey the history of Madrid in a close and accessible way.\n\nIn his tours, Carlos combines his historical knowledge with his enthusiasm for sharing it. His approachable, sociable and kind character turns each tour into a dynamic and enjoyable experience, where visitors not only discover the city's most iconic places, but also understand the stories and curiosities that make them unique. His goal is for each person who participates in the tour to find an authentic and memorable way to immerse themselves in the history and spirit of Madrid."
    },
    reviews: {
      title: "What our customers say",
      subtitle: "Thousands of tourists have enjoyed our tours"
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know"
    },
    gallery: {
      title: "Gallery",
      subtitle: "Moments from our tours"
    },
    contact: {
      title: "Contact",
      subtitle: "Have any questions?",
      whatsapp: "WhatsApp",
      email: "Email",
      phone: "Phone"
    },
    booking: {
      title: "Book Tour",
      selectTour: "Select a tour",
      selectDate: "Select date",
      selectTime: "Select time",
      guests: "Number of guests",
      adults: "Adults",
      children: "Children (under 140cm)",
      childSeats: "Child seats needed",
      contactInfo: "Contact information",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      pickup: "Pickup point",
      hotel: "Hotel name (optional)",
      pickupPoint: "Meeting point",
      pickupPoints: {
        opera: "Plaza de Isabel II (Opera)",
        neptuno: "Neptune Fountain",
        prado: "Prado Museum",
        debod: "Temple of Debod"
      },
      specialRequests: "Special requests (optional)",
      payment: "Payment method",
      payOnline: "Pay online (card)",
      payCash: "Pay cash (during the tour)",
      total: "Total",
      confirm: "Confirm Booking",
      payNow: "Pay Now",
      processing: "Processing...",
      success: "Booking Confirmed!",
      successMessage: "Your booking has been confirmed. You will receive an email with the details.",
      error: "Error processing booking",
      maxCapacity: "Maximum 4 passengers per tuk-tuk (adults and children included)",
      groupDiscount: "For groups of more than 10 people, contact us for special discounts."
    },
    footer: {
      tagline: "Discover Madrid through its history",
      tours: "Tours",
      info: "Information",
      contact: "Contact",
      schedule: "Schedule",
      summerSchedule: "Summer: 10:00 - 22:00",
      winterSchedule: "Winter: 10:00 - 19:00",
      everyDay: "Every day",
      rights: "All rights reserved"
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      tours: "Tours",
      reviews: "Avis",
      gallery: "Galerie",
      faq: "FAQ",
      book: "Réserver"
    },
    hero: {
      title: "Madrid Tuk Tuk Tour",
      subtitle: "Une visite privée de Madrid à travers son histoire",
      cta: "Réserver"
    },
    tours: {
      title: "Nos Tours",
      subtitle: "Découvrez Madrid d'une manière unique",
      duration: "Durée",
      from: "À partir de",
      viewMap: "Voir carte",
      book: "Réserver",
      option3h: "3 heures",
      option6h: "6 heures"
    },
    howItWorks: {
      title: "Comment ça marche?",
      step1: {
        title: "Réservez votre tour",
        desc: "Choisissez le tour de votre choix et sélectionnez la date et l'heure"
      },
      step2: {
        title: "Nous venons vous chercher",
        desc: "À votre hôtel ou au point de rencontre convenu"
      },
      step3: {
        title: "Parcourez Madrid",
        desc: "Profitez de la balade dans notre tuk-tuk électrique"
      },
      step4: {
        title: "Découvrez l'histoire",
        desc: "Apprenez sur Madrid avec notre guide historien"
      }
    },
    guide: {
      title: "Votre Guide",
      name: "Carlos Casal",
      age: "25 ans",
      role: "Historien",
      bio_short: "Carlos Casal, historien de 25 ans, est ne et a grandi a Madrid, une ville pour laquelle il ressent une profonde passion et curiosite historique. Des son plus jeune age, il s'est interesse a comprendre comment la ville s'est formee au fil des siecles et quel role elle a joue dans l'histoire de l'Espagne. Avec cette motivation, il a cree ces tours, dans le but d'offrir une facon differente de decouvrir Madrid: non seulement en parcourant ses rues, mais aussi en comprenant le contexte historique qui les a faconnees.",
      bio_rest: "Pendant plusieurs annees, il a vecu a l'etranger, principalement aux Etats-Unis et a Paris, une periode qui lui a permis d'elargir sa vision culturelle et de perfectionner ses langues, notamment l'anglais et le francais. Cette experience internationale l'a aide a se connecter avec des visiteurs de differents pays et a transmettre l'histoire de Madrid de maniere proche et accessible.\n\nDans ses tours, Carlos combine ses connaissances historiques avec son enthousiasme a les partager. Son caractere accessible, sociable et aimable transforme chaque tour en une experience dynamique et agreable, ou les visiteurs decouvrent non seulement les lieux les plus emblematiques de la ville, mais comprennent aussi les histoires et curiosites qui les rendent uniques. Son objectif est que chaque personne qui participe au tour trouve une maniere authentique et memorable de s'immerger dans l'histoire et l'esprit de Madrid."
    },
    reviews: {
      title: "Ce que disent nos clients",
      subtitle: "Des milliers de touristes ont apprécié nos tours"
    },
    faq: {
      title: "Questions Fréquentes",
      subtitle: "Tout ce que vous devez savoir"
    },
    gallery: {
      title: "Galerie",
      subtitle: "Moments de nos tours"
    },
    contact: {
      title: "Contact",
      subtitle: "Avez-vous des questions?",
      whatsapp: "WhatsApp",
      email: "Email",
      phone: "Téléphone"
    },
    booking: {
      title: "Réserver un Tour",
      selectTour: "Sélectionnez un tour",
      selectDate: "Sélectionnez une date",
      selectTime: "Sélectionnez l'heure",
      guests: "Nombre de personnes",
      adults: "Adultes",
      children: "Enfants (moins de 140cm)",
      childSeats: "Sièges enfants nécessaires",
      contactInfo: "Informations de contact",
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      pickup: "Point de récupération",
      hotel: "Nom de l'hôtel (optionnel)",
      pickupPoint: "Point de rencontre",
      pickupPoints: {
        opera: "Plaza de Isabel II (Opéra)",
        neptuno: "Fontaine de Neptune",
        prado: "Musée du Prado",
        debod: "Temple de Debod"
      },
      specialRequests: "Demandes spéciales (optionnel)",
      payment: "Mode de paiement",
      payOnline: "Payer en ligne (carte)",
      payCash: "Payer en espèces (pendant le tour)",
      total: "Total",
      confirm: "Confirmer la Réservation",
      payNow: "Payer Maintenant",
      processing: "Traitement...",
      success: "Réservation Confirmée!",
      successMessage: "Votre réservation a été confirmée. Vous recevrez un email avec les détails.",
      error: "Erreur lors du traitement de la réservation",
      maxCapacity: "Maximum 4 passagers par tuk-tuk (adultes et enfants inclus)",
      groupDiscount: "Pour les groupes de plus de 10 personnes, contactez-nous pour des réductions spéciales."
    },
    footer: {
      tagline: "Découvrez Madrid à travers son histoire",
      tours: "Tours",
      info: "Information",
      contact: "Contact",
      schedule: "Horaires",
      summerSchedule: "Été: 10:00 - 22:00",
      winterSchedule: "Hiver: 10:00 - 19:00",
      everyDay: "Tous les jours",
      rights: "Tous droits réservés"
    }
  }
};

export const useTranslation = (language) => {
  return translations[language] || translations.es;
};
